import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";
import { getTokens } from "../../styles/tokens";
import { ModalTitle, DangerButton } from "../FormFields/panel";

const useStyles = makeStyles((theme) => {
	const t = getTokens(theme.palette.type, theme.palette.primary.main);
	return {
		message: {
			margin: 0,
			fontSize: 14,
			lineHeight: 1.6,
			color: t.mode === "dark" ? t.text : t.label,
			overflowWrap: "anywhere",
		},
	};
});

// Quem chama raramente diz que a ação é destrutiva; o título quase sempre diz.
const DESTRUCTIVE = /exclu|delet|apag|remov|elimin|desconect|limpar|borrar/i;

const textOf = (node) => {
	if (node == null || typeof node === "boolean") return "";
	if (typeof node === "string" || typeof node === "number") return String(node);
	if (Array.isArray(node)) return node.map(textOf).join(" ");
	if (React.isValidElement(node)) return textOf(node.props.children);
	return "";
};

/**
 * Diálogo de confirmação de todas as telas.
 *
 * Props novas, todas opcionais: `destructive` (força/impede o botão vermelho — sem ela
 * o vermelho vale quando o título fala em excluir/remover/desconectar), `confirmText`,
 * `cancelText`.
 */
const ConfirmationModal = ({
	title,
	children,
	open,
	onClose,
	onConfirm,
	destructive,
	confirmText,
	cancelText,
}) => {
	const classes = useStyles();
	const isDestructive =
		typeof destructive === "boolean" ? destructive : DESTRUCTIVE.test(textOf(title));
	const ConfirmButton = isDestructive ? DangerButton : Button;

	return (
		<Dialog
			open={open}
			onClose={() => onClose(false)}
			aria-labelledby="confirm-dialog"
			maxWidth="xs"
			fullWidth
		>
			<ModalTitle id="confirm-dialog" title={title} />
			{children ? (
				<DialogContent>
					<div className={classes.message}>{children}</div>
				</DialogContent>
			) : null}
			<DialogActions>
				<Button onClick={() => onClose(false)}>
					{cancelText || i18n.t("confirmationModal.buttons.cancel")}
				</Button>
				<ConfirmButton
					variant="contained"
					color={isDestructive ? undefined : "primary"}
					onClick={() => {
						onClose(false);
						onConfirm();
					}}
				>
					{confirmText || i18n.t("confirmationModal.buttons.confirm")}
				</ConfirmButton>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
